module.exports = __webpack_public_path__ + "static/media/fire_board.c0ac3042.png";